module.exports = __webpack_public_path__ + "static/media/02(4).a7ea67c1.jpg";